import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { registerCapacitorDeepLinks } from "./capacitorBridge";
import { syncViewportHeight } from "./viewportSync";
import { setupAppZoom } from "./appZoom";
syncViewportHeight();
setupAppZoom();
registerCapacitorDeepLinks().catch(() => {
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
